// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const aboInfoBannerDetailsAPI = createApi({
  reducerPath: 'aboInfoBannerDetailsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAboSummaryDetails: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/summary`,
        method: 'GET',
      }),
    }),

    getAboAccountManager: builder.query<any, AccountManagerArgTypes | any>({
      query: ({ nativeId }) => ({
        url: `/auth/user/native/${nativeId}/detail`,
        method: 'GET',
      }),
    }),

    getAboPerformance: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/performance`,
        method: 'GET',
      }),
    }),

    getAboAward: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awards`,
        method: 'GET',
      }),
    }),

    getABOLOADetails: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/loa`,
        method: 'GET',
      }),
    }),
    getUplineDiamondInfo: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/uplinediamond`,
        method: 'GET',
      }),
    }),
  }),
});

// // Export hooks for usage in functional components, which are
// // auto-generated based on the defined endpoints
export const {
  useGetAboSummaryDetailsQuery,
  useGetAboAccountManagerQuery,
  useGetAboPerformanceQuery,
  useGetAboAwardQuery,
  useGetABOLOADetailsQuery,
  useGetUplineDiamondInfoQuery,
} = aboInfoBannerDetailsAPI;
